import addressTypes from '../../config/addressTypes'

export default {
  addressType: addressTypes.lookingLocal,
  packageName: "uk.gov.lookinglocal.scanstation.broxbourne"
}
